module.exports = __webpack_public_path__ + "static/media/cal-male-condom.478b62d9.jpg";